import React from 'react'
import { Container, Row, Col } from 'reactstrap'
import { string } from 'prop-types'
import { Section, Blockquote, Cite, TextContainer } from '../../GlobalStyles'
import Img from 'gatsby-image'

export const Testimonial = ({ blockquote, author, avatar }) => {
  return (
    <Section>
      <Container>
        <Row>
          <TextContainer as={Col} xs='12' md={{ size: 10, offset: 1 }}>
            <Blockquote>{blockquote}</Blockquote>
            <Cite>{author}</Cite>
            {avatar ? <Img fixed={avatar} /> : null}
          </TextContainer>
        </Row>
      </Container>
    </Section>
  )
}

Testimonial.propTypes = {
  blockquote: string.isRequired,
  author: string.isRequired
}

export default Testimonial
